<script lang="ts">
  import Cross from 'Components/InvestorFlow/icons/Cross.svelte';

  export let error: boolean = false;
  export let tooltipText: string = '';
  export let position: string = '';
  export let isFocused: boolean = false;
  export let inputName: string = '';
  export let fixedLayout: boolean = false;
</script>

<div class="oriented-tooltip" class:fixed-layout={fixedLayout}>
  <div
    data-testid="custom-tooltip"
    class:focus={isFocused && error}
    data-tooltip={tooltipText}
    data-tooltip-position={position}
  />
  <div class="cross" data-testid="tooltip-cross-{inputName}">
    <Cross {error} />
  </div>
</div>

<style>
  .oriented-tooltip {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .cross {
    position: absolute;
    margin-left: 19rem;
    margin-top: 0.84rem;
  }

  [data-tooltip] {
    display: inline-block;
    position: relative;
  }

  [data-tooltip]:before {
    content: attr(data-tooltip);
    background: #262626;
    color: #ffffff;
    padding: 0.5rem 0.5rem;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.375rem;
    min-width: 6.25rem;
    text-align: center;
    border-radius: 0.25rem;
    margin-top: -2.063rem;
  }

  [data-tooltip-position='top']:before {
    left: 17.188rem;
    -ms-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    bottom: calc(100% + 0.375rem - 0.688rem);
  }

  [data-tooltip]:after {
    content: '';
    border-color: transparent;
    border-style: solid;
    margin-top: -2.063rem;
  }

  [data-tooltip-position='top']:after {
    left: 17.188rem;
    margin-left: 1.813rem;
    margin-bottom: -0.688rem;
    bottom: 10%;
    border-width: 0.375rem 0.438rem 0;
    border-top-color: #262626;
  }

  [data-tooltip]:before,
  [data-tooltip]:after {
    visibility: hidden;
    position: absolute;
    opacity: 0;
    transition: opacity 1s;
  }

  .focus:before,
  .focus:after {
    visibility: visible;
    opacity: 1;
  }

  @media (max-width: 1000px) {
    [data-tooltip] {
      margin-left: -2.5rem;
    }
  }

  .fixed-layout {
    & [data-tooltip-position='top']:after {
      left: unset;
      right: 0.8rem;
    }

    & [data-tooltip-position='top']:before {
      left: unset;
      right: 0;
      max-width: 200px;
      -ms-transform: none;
      -moz-transform: none;
      -webkit-transform: none;
    }

    & .cross {
      right: 0.8rem;
    }

    @media (max-width: 1000px) {
      & :global(.form-icon) {
        margin-left: unset;
      }
    }
  }
</style>
